module.exports = __webpack_public_path__ + "img/06.6a87cfb7.jpg";